export const digitalCoEDataSources = [
  {
    title: 'SAP Center of Expertise',
    content:
      'Includes information on how to access the system, request roles, how to set approval delegations, how to login into the system, and some additional best practices to use the system.',
    sourceSystem: 'SAP CoE supporting documents library',
    prompts: [
      'How to request SAP access?',
      'How to request a new SAP role?',
      'How is COTD calculated?',
      'How to create a service Order?'
    ],
    datasourcelink:
      'https://hitachipowergrids.sharepoint.com/sites/SAP-CoE/Training%20recordings%20and%20videos/Forms/AllItems.aspx?csf=1&web=1&e=qTIdHF&CID=3eaa2779%2D262c%2D441c%2Da18b%2De4d92baa3305&FolderCTID=0x012000089F59108CBC114FB6A251688EDB719B&id=%2Fsites%2FSAP%2DCoE%2FTraining%20recordings%20and%20videos%2FAkira'
  }
]
